import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lib-loading-input',
  imports: [],
  templateUrl: './loading-input.component.html',
  styleUrl: './loading-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingInputComponent {}
